import React, { useState, useEffect } from "react";
import Utils from "../utils/utils";
import { useToast } from "./ToastContext";

const InstructorsList = ({ instructors, setInstructors }) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const token = Utils.getToken();

  const showToast = useToast();
  const [editingInstructor, setEditingInstructor] = useState(null);
  const [updatedInstructor, setUpdatedInstructor] = useState({
    name: "",
    email: "",
    mobile: "",
  });

  const handleEditClick = (instructor) => {
    setEditingInstructor(instructor);
    setUpdatedInstructor({
      name: instructor.name,
      email: instructor.email,
      mobile: instructor.mobile,
    });
  };

  const SaveInstEditedDetails = async (instId) => {
    if (!instId) {
      showToast("Instructor id is not provided", "error", true, 3000);
      return;
    }
    try {
      const response = await fetch(`${SERVER_URL}/instructors/${instId}`, {
        method: "PATCH",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(updatedInstructor),
      });

      if (response.ok) {
        const ret = await response.json();
        var updated = ret.instructor;
        showToast("Success", "success", false, 2000);
        setInstructors((prev) =>
          prev.map((inst) => (inst._id === updated._id ? updated : inst))
        );
        setUpdatedInstructor({
          name: "",
          email: "",
          mobile: "",
        });
        setEditingInstructor(null);
      } else {
        const ret = await response.json();
        showToast(ret.message, "error", true, 3000);
        console.error("Error submitting the form:", response.message);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const HandleCancelEditing = (e) => {
    e.preventDefault();
    setUpdatedInstructor({
      name: "",
      email: "",
      mobile: "",
    });
    setEditingInstructor(null);
  };

  const HandleInstructorDeletion =async (idTo) =>{
    const confirm = window.confirm('Are yu sure you want to delete instructor ?') ;
    if(!confirm ) return ;

    try {
      const response = await fetch(`${SERVER_URL}/instructors/${idTo}`, {
        method: "DELETE",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const ret = await response.json();
        var updated = ret.instructor;
        showToast("Success", "success", false, 2000);
        setInstructors((prev) =>
          prev.filter((inst) => (inst._id !== idTo ))
        );

      } else {
        const ret = await response.json();
        showToast(ret.message, "error", true, 3000);
        console.error("Error while deleting the Instructor", response.message);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  }

  return (
    <tbody>
      {instructors.map((instructor) => (
        <tr key={instructor._id}>
          <td className="w-[30%]" key={instructor._id+"Name"}>
            <div className="flex items-center gap-3">
              {editingInstructor?._id === instructor._id ? (
                <>
                  <div className="avatar">
                    <div className="mask mask-squircle h-12 w-12">
                      <div
                        className={`w-10 h-10 rounded-full text-md font-semibold flex justify-center items-center overflow-hidden text-white`}
                      ></div>
                    </div>
                  </div>
                  <div>
                    <div className="">
                      <input
                        type="text"
                        name="name"
                        value={updatedInstructor.name}
                        onChange={(e) =>
                          setUpdatedInstructor({
                            ...updatedInstructor,
                            name: e.target.value,
                          })
                        }
                        className="w-full text-left   input-sm px-4 py-3 rounded-lg bg-gray-50 border focus:border-pink-700 focus:bg-white focus:outline-none"
                      />
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="avatar">
                    <div className="mask mask-squircle h-12 w-12">
                      <div
                        className={`w-10 h-10 rounded-full text-md font-semibold flex justify-center items-center overflow-hidden ${Utils.getRandomBgColor()} text-white`}
                      >
                        {Utils.getUserAvatar(instructor.name)}
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="font-bold">{instructor.name}</div>
                  </div>
                </>
              )}
            </div>
          </td>

          <td className="w-[30%]">
            {editingInstructor?._id === instructor._id ? (
              <input
                type="email"
                name="email"
                value={updatedInstructor.email}
                onChange={(e) =>
                  setUpdatedInstructor({
                    ...updatedInstructor,
                    email: e.target.value,
                  })
                }
                className="w-full text-left   input-sm px-4 py-3 rounded-lg bg-gray-50 border focus:border-pink-700 focus:bg-white focus:outline-none"
              />
            ) : (
              <span>{instructor.email}</span>
            )}
          </td>

          <td className="w-[20%]">
            {editingInstructor?._id === instructor._id ? (
              <input
                type="tel"
                name="mobile"
                value={updatedInstructor.mobile}
                onChange={(e) =>
                  setUpdatedInstructor({
                    ...updatedInstructor,
                    mobile: e.target.value,
                  })
                }
                className="w-full text-left input-sm px-4 py-3 rounded-lg bg-gray-50 border focus:border-pink-700 focus:bg-white focus:outline-none"
              />
            ) : (
              <span>{instructor.mobile}</span>
            )}
          </td>

          <td className="w-[20%]">
            {editingInstructor?._id === instructor._id ? (
              <div className="flex gap-2">
                <button
                  onClick={() => SaveInstEditedDetails(instructor._id)}
                  className="px-2 py-1 flex justify-center items-center gap-1 btn-xs tracking-[.1em] uppercase border border-green-600 rounded-lg text-green-700 hover:text-green-800 hover:border-green-800 hover:shadow-lg"
                >
                  Save
                </button>

                <button
                  onClick={HandleCancelEditing}
                  className="px-2 py-1 flex justify-center items-center gap-1 btn-xs tracking-[.1em] uppercase border border-orange-600 rounded-lg text-orange-700 hover:text-orange-800 hover:border-orange-800 hover:shadow-lg"
                >
                  Cancel
                </button>
              </div>
            ) : (
              <div className="flex gap-2">
                <button
                  onClick={() => handleEditClick(instructor)}
                  className="px-2 py-1 flex justify-center items-center gap-1 btn-xs tracking-[.1em] uppercase border border-blue-600 rounded-lg text-blue-700 hover:text-blue-800 hover:border-blue-800 hover:shadow-lg"
                >
                  Edit
                </button>

                    <button
                  onClick={() => HandleInstructorDeletion(instructor._id)}
                  className="px-2 py-1 flex justify-center items-center gap-1 btn-xs tracking-[.1em] uppercase border border-red-600 rounded-lg text-red-700 hover:text-red-800 hover:border-red-800 hover:shadow-lg"
                >
                  Delete
                </button>
              </div>
            )}
          </td>
        </tr>
      ))}
    </tbody>
  );
};

export default InstructorsList;
